/**
 * Page de réinitialisation du mot de passe - React Vite
 */

import { useNavigate } from 'react-router-dom';
import { ResetPasswordForm } from '../components/forms/ResetPasswordForm';

export function ResetPasswordPage() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/auth/login');
  };

  const handleBackToLogin = () => {
    navigate('/auth/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-content">
            Réinitialiser le mot de passe
          </h2>
          <p className="mt-2 text-center text-sm text-content-muted">
            Entrez votre email pour recevoir un lien de réinitialisation
          </p>
        </div>
        <div className="bg-surface rounded-lg shadow-lg p-8">
          <ResetPasswordForm onSuccess={handleSuccess} />
          <div className="mt-4 text-center">
            <button
              onClick={handleBackToLogin}
              className="text-sm text-primary-text hover:text-primary"
            >
              Retour à la connexion
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
